


export const countDuplicatesItemArray = (value, array) => {
    let count = 1;
    array.forEach(arrayValue => {
      if (arrayValue.codigo === value) {
        count++;
      }
    });
    return count;
  };
  
//   export const removeArrayDuplicates = array => {
//     return Array.from(new Set(array));
//   };

export const removeArrayDuplicates = ( originalArray, prop ) => {

    let newArray = [];
    let lookUpObject = {};

    for ( let i in originalArray) {
        lookUpObject[originalArray[i][prop]] = originalArray[i]
    }

    for ( let i in lookUpObject ) {
        newArray.push( lookUpObject[i]);
    }

    return newArray;

}

export const countAllItems = ( originalArray, prop ) => {

    let lookUpObject = {};
    let count = 0;

    for ( let i in originalArray) {
        lookUpObject[originalArray[i][prop]] = originalArray[i]
        count++;
    }

    return count;

}

  
  export const removeItemArray = (array, item) => {
    const index = array.indexOf(item);
  
    if (index > -1) {
      array.splice(index, 1);
    }
    return array;
  };